<template>
  <div class="hello">
    <b-container fluid>
      <b-row>
        <b-col cols="12"><h2>Главная страница базы данных OORT</h2></b-col>
      </b-row>
      <b-row>
        <b-col cols="3"><MainButton text="Стадии" href_link="/study"/></b-col>
        <b-col cols="3"><MainButton text="Эксперименты" href_link="/exp"/></b-col>
        <b-col cols="3"><MainButton text="Контиги" href_link="/contig"/></b-col>
        <b-col cols="3"><MainButton text="Протеины" href_link="/protein"/></b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
  import MainButton from "./MainButton";
  export default {
    name: 'HelloWorld',
    components: {
      MainButton
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  text-align: center;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
